import {Injectable} from "@angular/core";
import {WebDataConnectionRun} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";
import {environment} from "@environments/environment";
import {ApiService} from "@app/_services/api.service";

@Injectable({
    providedIn: "root"
})
export class WebDataConnectionRunsService extends TableOptionsService<WebDataConnectionRun> {
    constructor(public apiService: ApiService) {
        super();
        this.pageSize = 25;
        this.sortDirection = "desc";
        this.sortColumn = "createdAt";
    }

    public override matches(element: WebDataConnectionRun, term: string) {
        return (
            element.key?.toLowerCase().includes(term.toLowerCase()) ||
            element.lastModified?.toLowerCase().includes(term.toLowerCase())
        );
    }

    downloadRawFile(customerId: string, webDataConnectionId: string, fileName: string, versionId: string): void {
        const endpoint = `${environment.apiUrl}/admin/customers/${customerId}/webDataConnection/${webDataConnectionId}/file/${fileName}/version/${versionId}`;
        this.apiService.handleDownloadFile(endpoint);
    }
}
